import React, { useEffect } from "react";
import DocuSignSuccessUI from "./completed";
import { useDispatch } from "react-redux";
import { getdocuSignCompleted } from "../TaskmanagementVendor/TaskmanagementVendor.Action";
import SignatureSuccessPopup from "./signature";
import { setDrawerVisible } from "../TaskmanagementVendor/TaskmanagementVendor.Slice";

const Index = (props) => {
  //   const {
  //     intl: { formatMessage },
  //   } = props;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const codeParam = urlSearchParams.get("signature");
  const taskId = urlSearchParams.get("taskId");
  console.log("codeParam", codeParam);
  const dispatch = useDispatch();
  useEffect(() => {
    if (codeParam && taskId) {
      dispatch(
        getdocuSignCompleted({
          taskId: taskId,
          envelopeId: codeParam,
          isGuestUser: true,
          signature: codeParam,
        })
      );
    }
  }, [codeParam, taskId, dispatch]);
  return (
    <div style={{height:"100vh"}}>
      {codeParam == 1 ? <DocuSignSuccessUI /> : ""}
      {codeParam == 2 ? <SignatureSuccessPopup /> : ""}
    </div>
  );
};

export default Index;
